import React from "react";
import ReactDOM from "react-dom";

export default function OrderCancel({ isOpen, onSetClose, onOrderCancel }) {
    
  if (isOpen !== "OrderCancel") return null;
  return ReactDOM.createPortal(
    <div className="uk-modal-dialog uk-margin-auto-vertical">
      <button
        className="uk-modal-close-default"
        type="button"
        uk-close="true"
      ></button>

      <div className="uk-modal-body uk-text-center">
        <p className="uk-text-secondary">
          <i className="far fa-question-circle fa-3x"></i>
        </p>
        <p className="uk-h4">Cancelar pedido</p>
        <p>
          No podrás revertir esto, y su pago sera reversado en un lapso maximo
          de 24 horas.
        </p>
      </div>

      <div className="uk-modal-footer uk-text-center">
        <button
          onClick={() => onSetClose()}
          className="uk-button uk-modal-close uk-button-custom"
        >
          <span>No</span> <i className="fas fa-times"></i>
        </button>
        <button
          onClick={() => onOrderCancel()}
          className="uk-button uk-modal-close uk-button-default uk-button-custom"
          type="button"
        >
          <span>Si, deseo cancelar</span> <i className="fas fa-check"></i>
        </button>
      </div>
    </div>,
    document.getElementById("webModal")
  );
}
